;(function () {
  'use strict'
  angular
    .module('contrast.freemium.registration')
    .factory(
      'freemiumRegistrationApiConfig',
      function freemiumRegistrationApiConfigFactory($http) {
        'ngInject'

        return {
          validate: validate,
          activate: activate
        }

        function validate(token) {
          return $http.get('/Contrast/api/public/ng/freemium/validate/' + token)
        }

        function activate(data) {
          return $http.post('/Contrast/api/public/ng/freemium/activation', data)
        }
      }
    )
})()
